/* Steelmonks Warenkorb-Namen (20.10.2026)
   Zepto schreibt die Beschriftung seiner Felder als Namen der Zeileneigenschaft, mit Auszeichnung: „<b>Straßenname<b>“, „-<b>Hausnummer<b>“,
   „Wunschtext “. Drawer und Warenkorbseite zeigen die Namen ohne Tags, die Kasse aber wörtlich („<b>Straßenname<b>: AM FEIERABEND“).
   Dieses Skript benennt die sichtbaren Namen im Warenkorb um, bevor es über das Theme zur Kasse geht.
   Regel: Tags weg, Leerraum zusammengefasst und am Rand weg, führendes - weg. Namen mit _ am Anfang (_pc_pricing_ref, _pc_pricing_qty_split,
     _pplr_preview, _Vorschau ...) bleiben, ebenso alle Werte und die Reihenfolge. Zeptos Zusatzzeilen hängen nur an _pc_pricing_ref und bleiben verbunden.
   Je Zeile ein POST /cart/change.js {id: Zeilenschlüssel, quantity, properties}, nacheinander und per Schlüssel, nie per Position. Eine Zeile bleibt,
     wie sie ist, wenn zwei Namen gleich würden, ein Name leer bliebe oder sie ein Abo hat. Steht schon eine gleiche saubere Zeile im Warenkorb,
     legt Shopify beide zusammen (Menge addiert).
   Wann: beim Öffnen des Drawers und beim Laden der Warenkorbseite, wenn layout/theme.liquid beim Laden eine solche Zeile gefunden hat (data-roh)
     oder seitdem etwas in den Warenkorb gelegt wurde (dann einmal /cart.js). Ein sauberer Warenkorb kostet keine Anfrage.
   Kasse: jedes Absenden eines Formulars an /cart mit name=checkout (Drawer „Zur Kasse“, Warenkorbseite, Leiste unten) wird angehalten, bereinigt
     und dann fortgesetzt; nach höchstens 4 s geht es unverändert weiter. Express-Knöpfe (Shop Pay, PayPal, Google Pay) lesen den Warenkorb beim
     Klick, sie sind nur ausgeblendet, solange ein Lauf dauert.
   Zeilenschlüssel: nach jeder Änderung bekommt die Zeile einen neuen Schlüssel. Er wird sofort in data-sm-line-key der Entfernen-Knöpfe
     eingetragen (Zuordnung über Variante und Eigenschaften aus der Antwort, nicht über die Position). Ein Klick auf Entfernen, während eine
     Änderung unterwegs ist, wird angehalten und danach mit dem neuen Schlüssel ausgeführt. Wurde die Zeile mit einer gleichen sauberen Zeile
     zusammengelegt, zieht Entfernen ihre Menge von der gemeinsamen Zeile ab.
   Danach werden Drawer und Warenkorbseite neu aufgebaut. Ging es dabei zur Kasse, geschieht das erst, wenn die Seite aus dem Zwischenspeicher
     zurückkommt (Zurück aus der Kasse). sm:cart-changed wird nicht ausgelöst: Summe und Stückzahl bleiben gleich.
   Nicht erfasst: /checkout direkt und Links aus der Erinnerungsmail. Vollständig hilft nur ein eigener Feldname je Feld in Zepto. */
(function () {
  'use strict';
  var W = window, D = document, H = D.documentElement;
  if (W.smWarenkorbNamen) return;
  // Läuft schon der Bereiniger aus sm-korb-schild-bereiniger.js (Theme-Einstellung) oder fehlt fetch, bleibt dieses Skript still
  // (der Platzhalter gibt den Kassen-Halt aus layout/theme.liquid frei)
  if (W.SMKorbBereiniger || !W.fetch || !W.Promise) { W.smWarenkorbNamen = { aus: true }; H.classList.remove('sm-wk-namen-laeuft'); return; }

  var tag = D.querySelector('script[data-sm-wk-namen]');
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var FRIST = 4000;                   // so lange wartet „Zur Kasse“ höchstens
  var SCHREIB = /\/cart\/(add|change|update|clear)\b/, ADD = /\/cart\/add\b/, MERK = 'sm_wk_namen';
  var holen = W.fetch;                // eigene Anfragen laufen am Zähler unten vorbei
  var faellig = !!(tag && tag.getAttribute('data-roh'));   // true: es könnte eine Zeile mit Auszeichnung geben
  var lauf = null, stand = 0, fremd = 0, schreib = 0, kasse = false, knopf = null, timer = 0, zuletzt = merkLesen();
  var stur = {};                      // Zeilen, die Shopify nicht ändern ließ (z. B. 422): auf dieser Seite nicht noch einmal versuchen
  var flug = false, halt = [], frei = false;   // eine eigene Änderung ist unterwegs; angehaltene Klicks auf Entfernen
  var alt = false;                    // Zeilen geändert, Drawer und Warenkorbseite noch nicht neu aufgebaut

  function sauber(k) {
    return String(k).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').replace(/^[\s-]+|\s+$/g, '');
  }
  // Neue Eigenschaften als Liste [Name, Wert] in alter Reihenfolge, oder null (nichts zu tun oder nicht eindeutig)
  function neu(p) {
    var liste = [], da = {}, anders = false, k, n;
    for (k in p) {
      if (!Object.prototype.hasOwnProperty.call(p, k)) continue;
      n = k.charAt(0) === '_' ? k : sauber(k);
      if (!n || da['#' + n]) return null;
      da['#' + n] = 1;
      if (n !== k) anders = true;
      liste.push([n, p[k] === undefined ? null : p[k]]);
    }
    return anders ? liste : null;
  }
  // Gleiche Eigenschaften wie die gesendete Liste (Reihenfolge egal, die Namen sind eindeutig)
  function gleich(p, liste) {
    var z = 0, i, k;
    p = p || {};
    for (k in p) if (Object.prototype.hasOwnProperty.call(p, k)) z++;
    if (z !== liste.length) return false;
    for (i = 0; i < liste.length; i++) {
      if (!Object.prototype.hasOwnProperty.call(p, liste[i][0]) || JSON.stringify(p[liste[i][0]]) !== JSON.stringify(liste[i][1])) return false;
    }
    return true;
  }
  function knoepfe(k) {
    return [].filter.call(D.querySelectorAll('[data-sm-line-key]'), function (el) { return el.getAttribute('data-sm-line-key') === k; });
  }
  function knopfZu(k, drawer) {
    return knoepfe(k).filter(function (el) { return el.nodeName === 'CART-REMOVE-BUTTON' && !!el.closest('cart-drawer') === drawer; })[0] || null;
  }
  // Antwort von change.js: neue Zeile suchen und die Knöpfe der alten Zeile umstellen. Zusammengelegt (die saubere Zeile gab es schon):
  // die alten Knöpfe merken sich Schlüssel und Mengen, damit Entfernen nur die eigene Menge abzieht
  function merken(it, liste, c, da) {
    var m = (c.items || []).filter(function (j) { return j.variant_id === it.variant_id && gleich(j.properties, liste); })[0];
    if (!m) return null;
    var w = { a: it.key, k: m.key, q: +it.quantity, n: +m.quantity, z: !!da[m.key] || +m.quantity !== +it.quantity };
    da[m.key] = 1;
    knoepfe(it.key).forEach(function (el) { if (w.z) el.__smWk = w; else el.setAttribute('data-sm-line-key', m.key); });
    return w;
  }
  // Entfernen ausführen: wie Dawn über den Knopf, bei einer zusammengelegten Zeile über die Menge der gemeinsamen Zeile
  function entfernen(b, w) {
    w = w || b.__smWk;
    if (!w) { frei = true; b.dispatchEvent(new Event('click')); frei = false; return; }
    var z = knopfZu(w.k, !!b.closest('cart-drawer')) || b, ci = z.closest('cart-items') || z.closest('cart-drawer-items');
    if (ci && ci.updateQuantity) ci.updateQuantity(z.dataset.index, Math.max(0, w.n - w.q), undefined, undefined, w.k);
  }
  // Angehaltene Klicks nach der Antwort (w: Zuordnung dieser Änderung) oder nach höchstens 5 s ausführen
  function loslassen(w) {
    var h = halt;
    halt = [];
    h.forEach(function (x) {
      var b = x.b, v = null;
      if (!H.contains(b)) {               // inzwischen neu aufgebaut: Knopf über den aktuellen Schlüssel suchen
        if (w && w.a === x.k) { v = w.z ? w : null; b = knopfZu(w.k, x.d); } else b = knopfZu(x.k, x.d);
        if (!b) return;
      }
      entfernen(b, v);
    });
  }
  function merkLesen() { try { return W.localStorage.getItem(MERK); } catch (e) { return null; } }
  function warte(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }
  // Warten, bis keine fremde Schreibanfrage an den Warenkorb mehr läuft (höchstens 2 s), damit sich Änderungen nicht überholen
  function ruhig() {
    var t0 = Date.now();
    return new Promise(function (ok) {
      (function schau() { if (!fremd || Date.now() - t0 > 2000) ok(); else setTimeout(schau, 50); })();
    });
  }
  // Ohne Accept-Kopf: /cart?sections=... liefert mit „Accept: application/json“ den Warenkorb statt der Abschnitte
  function lesen(u) {
    return holen.call(W, ROOT + u + (u.indexOf('?') < 0 ? '?' : '&') + 'sm_wk=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  // Text des Körpers selbst gebaut, damit die Reihenfolge der Namen sicher bleibt
  function aendern(it, liste) {
    var b = '{"id":' + JSON.stringify(it.key) + ',"quantity":' + (+it.quantity) + ',"properties":{' +
      liste.map(function (x) { return JSON.stringify(x[0]) + ':' + JSON.stringify(x[1]); }).join(',') + '}}';
    return holen.call(W, ROOT + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: b });
  }
  // Drawer und Warenkorbseite neu aufbauen (eine Anfrage für beide). Ändert ein anderes Skript den Warenkorb, während die Abschnitte
  // unterwegs sind (z. B. Entfernen), wäre ihr Stand veraltet: dann verwerfen und nach dessen Ende neu holen (höchstens zweimal)
  function zeichnen(v) {
    var mc = D.getElementById('main-cart-items'), mid = mc && mc.getAttribute('data-id'), di = D.querySelector('cart-drawer-items'), ids = [], w0;
    if (di) ids.push('cart-drawer');
    if (mid) ids.push(mid);
    if (!ids.length) return Promise.resolve();
    return ruhig().then(function () { w0 = schreib; return lesen('cart?sections=' + ids.join(',')); }).then(function (s) {
      var P = new DOMParser(), d, m, z;
      if (schreib !== w0 || fremd) return (v || 0) < 2 ? zeichnen((v || 0) + 1) : 0;
      di = D.querySelector('cart-drawer-items');
      if (di && s['cart-drawer']) {
        d = P.parseFromString(s['cart-drawer'], 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var bisher = D.querySelector(sel), frisch = d.querySelector(sel);
          if (bisher && frisch) bisher.parentNode.replaceChild(frisch, bisher);
        });
      }
      if (mid && s[mid]) {
        m = P.parseFromString(s[mid], 'text/html').querySelector('.js-contents');
        z = (D.getElementById('main-cart-items') || mc).querySelector('.js-contents');   // neu gesucht: ein anderes Skript kann den Bereich inzwischen ersetzt haben
        if (m && z) z.innerHTML = m.innerHTML;
      }
      alt = false;
    });
  }

  function pruefen() {
    if (lauf) return lauf;
    if (!faellig) return Promise.resolve(0);
    var s0 = stand, n = 0, fehler = false;
    H.classList.add('sm-wk-namen-laeuft');
    // Eine Runde: lesen, betroffene Zeilen nacheinander ändern, dann noch einmal lesen. Eine gleichzeitige fremde Schreibanfrage
    // (z. B. Warenkorb-Attribute einer App) kann eine Änderung überschreiben; deshalb erst sauber, wenn ein Lesen nichts mehr findet (höchstens 3 Runden)
    function runde(r) {
      return ruhig().then(function () { return lesen('cart.js'); }).then(function (c) {
        var todo = [], da = {};
        (c.items || []).forEach(function (it) {
          var l = !it.selling_plan_allocation && !stur[it.key] && neu(it.properties);
          da[it.key] = 1;
          if (l) todo.push([it, l]);
        });
        if (!todo.length) return;
        if (r >= 3) { fehler = true; return; }
        return todo.reduce(function (p, x) {
          var w = null;
          return p.then(ruhig).then(function () { flug = true; return aendern(x[0], x[1]); }).then(function (a) {
            if (!a.ok) { stur[x[0].key] = 1; return; }
            n++; alt = true;
            return a.json().then(function (c2) { w = merken(x[0], x[1], c2, da); }, function () { /* ohne Antwort bleiben die Knöpfe bis zum Neuaufbau alt */ });
          }).then(null, function () { fehler = true; }).then(function () { flug = false; loslassen(w); });
        }, Promise.resolve()).then(function () { return runde(r + 1); });
      });
    }
    lauf = runde(0).then(function () { if (stand === s0 && !fehler) faellig = false; }, function () { /* Netz weg: beim nächsten Anlass noch einmal */ })
      .then(function () { return n && !kasse ? zeichnen() : 0; })
      .then(null, function () { /* Neuaufbau misslungen: die Zeilen sind trotzdem sauber */ })
      .then(function () {
        lauf = null;
        H.classList.remove('sm-wk-namen-laeuft');
        if (stand !== s0) bald();   // während des Laufs kam etwas dazu
        return n;
      });
    return lauf;
  }
  function sichtbar() {
    var dr = D.querySelector('cart-drawer');
    return !!(D.getElementById('main-cart-items') || (dr && dr.classList.contains('active')));
  }
  function bald() {
    clearTimeout(timer);
    timer = setTimeout(function () { if (faellig && sichtbar()) pruefen(); }, 150);
  }
  function hinzu() {
    faellig = true; stand++; bald();
  }

  // Fremde Schreibanfragen an den Warenkorb zählen; nach jedem Hinzufügen ist eine Prüfung fällig
  function fertig(u, ok) {
    fremd = Math.max(0, fremd - 1);
    if (ok && ADD.test(u)) {
      hinzu();
      try { zuletzt = String(Date.now()); W.localStorage.setItem(MERK, zuletzt); } catch (e) { /* ohne Speicher: nur dieser Tab */ }
    }
  }
  W.fetch = function (input) {
    var u = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    var p = holen.apply(W, arguments);
    if (SCHREIB.test(u)) {
      fremd++; schreib++;
      p.then(function (r) { fertig(u, r && r.ok); }, function () { fertig(u, false); });
    }
    return p;
  };
  var XP = W.XMLHttpRequest && W.XMLHttpRequest.prototype;
  if (XP) {
    var xOpen = XP.open, xSend = XP.send;
    XP.open = function (m, u) { this.__smWkUrl = u ? String(u) : ''; return xOpen.apply(this, arguments); };
    XP.send = function () {
      var x = this, u = x.__smWkUrl;
      if (u && SCHREIB.test(u)) {
        fremd++; schreib++;
        x.addEventListener('loadend', function () { fertig(u, x.status >= 200 && x.status < 300); });
      }
      return xSend.apply(x, arguments);
    };
  }
  D.addEventListener('sm:cart-changed', hinzu);
  // Ein anderer Tab hat etwas in den Warenkorb gelegt
  W.addEventListener('storage', function (e) { if (e.key === MERK) { zuletzt = e.newValue; hinzu(); } });

  // Drawer geht auf
  var dr = D.querySelector('cart-drawer'), auf = !!(dr && dr.classList.contains('active'));
  if (dr && W.MutationObserver) new MutationObserver(function () {
    var jetzt = dr.classList.contains('active');
    if (jetzt && !auf && faellig) pruefen();
    auf = jetzt;
  }).observe(dr, { attributes: true, attributeFilter: ['class'] });

  // Entfernen: während eine eigene Änderung unterwegs ist, anhalten (Dawn schickte sonst den alten Schlüssel, Antwort 400);
  // an einer zusammengelegten Zeile die eigene Menge abziehen
  W.addEventListener('click', function (e) {
    var b = !frei && e.target && e.target.closest ? e.target.closest('cart-remove-button') : null;
    if (!b || (!flug && !b.__smWk)) return;
    e.preventDefault();
    e.stopPropagation();
    if (!flug) { entfernen(b); return; }
    var x = { b: b, k: b.getAttribute('data-sm-line-key'), d: !!b.closest('cart-drawer') };
    halt.push(x);
    setTimeout(function () {             // Antwort bleibt aus: nach 5 s trotzdem ausführen
      if (halt.indexOf(x) < 0) return;
      halt = halt.filter(function (y) { return y !== x; });
      if (H.contains(b)) entfernen(b);
    }, 5000);
  }, true);

  // Kasse: anhalten, bereinigen, weiter
  D.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button[name="checkout"], input[name="checkout"]') : null;
    if (b) knopf = b;
  }, true);
  function kassenForm(f, b) {
    if (!f || f.nodeName !== 'FORM' || String(f.method).toLowerCase() !== 'post') return false;
    if (!/\/cart\/?([?#]|$)/.test(f.getAttribute('action') || '')) return false;
    return !!((b && b.name === 'checkout') || f.querySelector('input[type="hidden"][name="checkout"]'));
  }
  W.addEventListener('submit', function (e) {
    var f = e.target, b = e.submitter || (knopf && knopf.form === f ? knopf : null);
    if (!kassenForm(f, b) || f.getAttribute('data-sm-wk-weiter')) return;
    if (!faellig && !lauf) return;                  // sauber: unverändert weiter, keine Anfrage
    if (e.defaultPrevented) { pruefen(); return; }  // hält schon ein anderer an, dann nur schon einmal prüfen
    e.preventDefault();
    e.stopPropagation();
    if (kasse) return;                              // wartet schon (Doppelklick)
    kasse = true;
    H.classList.add('sm-wk-namen-wartet');
    var fid = f.id, bid = b && b.id;
    Promise.race([pruefen(), warte(FRIST)]).then(weiter, weiter);
    function weiter() {
      var g = H.contains(f) ? f : (fid && D.getElementById(fid)), k = b && H.contains(b) ? b : (bid && D.getElementById(bid));
      if (!g) { W.location.href = ROOT + 'checkout'; return; }
      if (k && k.form !== g) k = null;
      g.setAttribute('data-sm-wk-weiter', '1');
      setTimeout(function () {
        g.removeAttribute('data-sm-wk-weiter');
        kasse = false;
        H.classList.remove('sm-wk-namen-wartet');
      }, 3000);
      try {
        if (k && g.requestSubmit) { g.requestSubmit(k); return; }
        feld(g);
        if (g.requestSubmit) g.requestSubmit(); else g.submit();
      } catch (x) { feld(g); g.submit(); }
    }
  }, true);
  function feld(g) {
    if (g.querySelector('input[type="hidden"][name="checkout"]')) return;
    var i = D.createElement('input');
    i.type = 'hidden'; i.name = 'checkout'; i.value = '1';
    g.appendChild(i);
  }
  // Zurück aus der Kasse (Seite aus dem Zwischenspeicher): Wartezustand lösen, den vor der Kasse ausgelassenen Neuaufbau nachholen;
  // geprüft wird nur, wenn ein anderer Tab etwas hinzugefügt hat
  W.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    kasse = false;
    H.classList.remove('sm-wk-namen-wartet');
    [].forEach.call(D.querySelectorAll('[data-sm-wk-weiter]'), function (g) { g.removeAttribute('data-sm-wk-weiter'); });
    if (alt && !lauf) zeichnen().then(null, function () { /* die Knöpfe tragen die neuen Schlüssel schon */ });
    var m = merkLesen();
    if (m !== zuletzt) { zuletzt = m; hinzu(); }
  });

  W.smWarenkorbNamen = { pruefen: pruefen, sauber: sauber, faellig: function () { return faellig; } };
  if (faellig && sichtbar()) pruefen(); else H.classList.remove('sm-wk-namen-laeuft');
})();
